import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatNativeDateModule, MatPaginatorModule, MatSelectModule, MatSortModule, MatTableModule, MatTooltip, MatTooltipModule } from '@angular/material';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { RouterModule, Routes } from '@angular/router';
import { AddSupportComponent } from './add-support.component';


const routes: Routes = [
    {
        path: '',
        component: AddSupportComponent,
        data: {
            title: 'Support Ticket'
        }
    }
];

@NgModule({
    declarations: [AddSupportComponent],
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatIconModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        FormsModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule, AddSupportComponent],
})
export class AddSupportModule { }

